__webpack_require__.p = "/health-literacy/";